import { ApolloCache } from "@apollo/client"

import { QueryTypename } from "shared/api/types"
import { sortByPositionAndUpdateIndex } from "shared/lib/sorting/sortByPosition"
import { Project, ProjectTypename } from "shared/types/Project"

import { updateProjectChildren } from "entities/project-children/lib/updateProjectChildren"
import {
  ProjectDocument,
  ProjectQuery,
  ProjectQueryVariables,
  ProjectsDocument,
  ProjectsQuery,
  ProjectsQueryVariables
} from "entities/projects/graphql/queries.generated"

import { readProjects } from "./readProjects"

export function createProjectInCache({
  cache,
  project,
  writeChildrenQuery = true
}: {
  cache: ApolloCache<object>
  project?: Project | null
  writeChildrenQuery?: boolean
}) {
  if (project) {
    const projects = readProjects(cache)

    if (projects) {
      projects
        .splice(project.position || 0, 0, project)
        .map((c, index) => ({ ...c, position: index + 1 }))

      cache.writeQuery<ProjectsQuery, ProjectsQueryVariables>({
        data: {
          projects: sortByPositionAndUpdateIndex(projects),
          __typename: QueryTypename
        },
        query: ProjectsDocument
      })
      cache.writeQuery<ProjectQuery, ProjectQueryVariables>({
        data: { project, __typename: QueryTypename },
        query: ProjectDocument,
        variables: { id: project.id }
      })
      if (writeChildrenQuery) {
        updateProjectChildren({
          parentID: project.id,
          parentType: ProjectTypename,
          cache,
          children: []
        })
      }
    }
  }
}
